import axios from 'axios';
import { APP_CONFIG } from '../app-constants';

// create api (axios) instance
const authApiInstance = axios.create({
  baseURL: APP_CONFIG.authBasePath,
});

const apiGetWithAuthHeaders = (dispatch, endpoint, success, failure, parsedHash, locationHash) => authApiInstance.get(endpoint,
  { headers: { Authorization: `Bearer ${parsedHash.access_token}` } })
  .then((response) => {
    dispatch(success(response.data, locationHash));
  })
  .catch((error) => {
    dispatch(failure(error));
  });

export default apiGetWithAuthHeaders;
